export default "__VITE_ASSET__328d1cb8__"